import { FormattedMessage } from "react-intl";
import { GroupedTrackingHistoryItem } from "../GroupedTrackingHistory/GroupedTrackingHistory";

interface PortcastAirDetailsProps {
  history: GroupedTrackingHistoryItem[];
}

export default function PortcastAirDetails({ history }: PortcastAirDetailsProps) {
  const firstItem = history?.[0]?.history?.[0];
  const piece = firstItem?.piece;
  const weight = firstItem?.weight;
  const airline = firstItem?.airline;

  if (!airline) return null;

  return (
    <div className="d-flex gap-xl mb-xl">
      <div className="grouped-tracking-history__group flex-1 mb-0">
        <p className="text-tertiary text-xs mb-0">
          <FormattedMessage id="tracking.portcastAir.shipmentWeight" defaultMessage="Shipment weight" />
        </p>
        <p className="mb-0 text-sm font-medium">
          {piece && (
            <span>
              {piece} pc{piece === 1 ? "" : "s"} •{" "}
            </span>
          )}
          {weight && <span>{new Intl.NumberFormat().format(weight)} kg</span>}
        </p>
      </div>
      <div className="grouped-tracking-history__group flex-1 mb-0">
        <p className="text-tertiary text-xs mb-0">
          <FormattedMessage id="tracking.portcastAir.manageBy" defaultMessage="Manage by" />
        </p>
        <p className="mb-0 text-sm font-medium">{airline}</p>
      </div>
    </div>
  );
}
